import React from 'react';
import advocateProfilePic from '../../../assets/images/advocates-details/rajani.png';

const AdvocateRajaniDetails = () => {
  return (
    <section className='team-details'>
      <div className='container'>
        <div className='row justify-content-between'>
          <div className='col-lg-5'>
            <div className='team-details__content'>
              <h2 className='team-details__title'>Read my story</h2>
              <p className='team-details__text'>
                Ms. B. Rajani did her LLB and graduated from Pendekanti Law
                College, Hyderabad. She enrolled as an Advocate in the year
                2015. She is having a good experience in dealing with Family
                cases. She practices in Family Courts, Administrative Tribunal
                and Civil Courts.
              </p>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='team-one__single'>
              <div className='team-one__image' style={{ textAlign: 'center' }}>
                <img
                  src={advocateProfilePic}
                  alt='Ms. B. Rajani Rathod'
                  style={{
                    objectFit: 'cover',
                    objectPosition: 'center center',
                    display: 'block',
                    margin: '0 auto',
                    maxWidth: '100%',
                    height: 'auto',
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none'
                  }}
                />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>Ms. B. Rajani Rathod. LLB</h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvocateRajaniDetails;

